import { Icon, Tag } from '@scale/scaleui';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';

type ProjectOutlineSectionStatusProps = {
  status: ProjectOutlineNodeStatus;
};

export const ProjectOutlineSectionStatus = ({ status }: ProjectOutlineSectionStatusProps) => {
  if (status === ProjectOutlineNodeStatus.NOT_STARTED) {
    return (
      <Icon
        icon="lock"
        size="sm"
        tooltip={`Please complete the previous step to unlock this item`}
        tooltipProps={{ side: 'top' }}
      />
    );
  }

  if (status === ProjectOutlineNodeStatus.IN_PROGRESS) {
    return (
      <Tag size="sm" className="bg-neutral-200">
        <Icon icon="spinner" size="sm" className="text-misc-periwinkle100" />
        <span className="text-misc-periwinkle100">In progress</span>
      </Tag>
    );
  }

  if (status === ProjectOutlineNodeStatus.COMPLETED) {
    return <Icon icon="check-circle" size="sm" variant="neutral" />;
  }

  return <span className="text-xs text-neutral-700">{status}</span>;
};
